<template>
  <section id="download">
    <v-container fluid class="download-section d-flex align-center">
      <v-row align="center" justify="center">
        <v-col cols="10" lg="8">
          <v-row align="center" justify="center">
            <v-col sm="5" class="hidden-xs-only d-flex justify-center">
              <v-img
                src="@/assets/undraw_cloud-files_8upc.svg"
                class="d-block"
                max-width="300px"
                style="opacity: 0.85"
              />
            </v-col>
            <v-col cols="12" sm="7">
              <p class="section-overline mb-2">DEMONSTRAÇÃO</p>
              <h2 class="download-title mb-4">Experimente o Salvia</h2>
              <p class="download-subtitle mb-6">
                Crie sua conta e descubra como o Salvia pode otimizar sua rotina
                de atendimento.
              </p>
              <v-btn
                rounded
                large
                color="primary"
                dark
                depressed
                class="btn-primary-custom"
                @click="startSignup"
              >
                <v-icon class="mr-2" small>mdi-rocket-launch-outline</v-icon>
                Testar demonstração
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "DownloadSection",

  methods: {
    // Não existe binário para baixar: a "demonstração" é a própria conta.
    // O botão leva direto para a etapa de cadastro do LoginPage.
    startSignup() {
      this.$router.push({
        name: "LoginPage",
        query: { step: "2", origem: "demo" },
      });
    },
  },
};
</script>

<style scoped>
.download-section {
  background-color: #111111;
  min-height: 420px;
  padding: 80px 0;
}

.section-overline {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 2px;
  color: var(--ds-primary);
  text-transform: uppercase;
}

.download-title {
  font-size: 2.25rem;
  font-weight: 600;
  color: var(--ds-white);
  letter-spacing: -0.3px;
  line-height: 1.2;
}

.download-subtitle {
  font-size: 1.05rem;
  font-weight: 300;
  color: rgba(255, 255, 255, 0.55);
  line-height: 1.65;
  max-width: 440px;
}

.btn-primary-custom {
  text-transform: none !important;
  font-weight: 500;
  letter-spacing: 0.2px;
}

@media (max-width: 960px) {
  .download-title {
    font-size: 1.75rem;
  }
}
</style>
